import Identificacion from "../Comun/Identificacion";

export default class ParametroDetalleRevocacion {

    constructor(){
        this.NumeroRevocatoria = "";
        this.TipoAutorizacion = 0;
        this.Identificacion = new Identificacion();
        this.EntidadAutorizada = "";
        this.EntidadUsuario = "";
    }

      NumeroRevocatoria  : string;
      TipoAutorizacion: number;
     Identificacion: Identificacion; 
     EntidadAutorizada : string;
     EntidadUsuario : string;
}